<template>
  <img v-if="seen" :class="{expand: isExpanded}" :src="src" :style="style" :alt="productDesc" />
</template>

<script>
import {getClosestDPI} from "@/store/modules/scale";
import {mapGetters} from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import FeatureMixin from "@/mixins/featureMixin";

export default {
	name: "ImageElement",
	mixins:[blockElementMixin, FeatureMixin],
  data(){
    return{
      featurePath: "image"
    }
  },
	props:{
		constrain:{
			type: Object,
			default: () => {
				return {'width': null, 'height': null}
			}
		},
		adSrc: {
			type: String,
			default: null
		}
	},
  methods:{
    getFillVal(){
      return this._config?.expansion !==undefined ?  this._config?.expansion : 1;
    },
	getMinDPI(dpi) {
		  const minDPI = 144;
		  return Math.max(dpi, minDPI);
			  
	  }
  },
	computed:{
		...mapGetters('scale', ['imageDPI']),

		resolutions(){
			return this.blockData.images;
		},
		currentResolution(){
			let dpi = this.imageDPI;
			const images = this.resolutions;
			if (this._config?.setMinDPI ) dpi = this.getMinDPI(dpi)
			return getClosestDPI(dpi, images);
		},
		src(){
			return  this.adSrc || this.currentResolution?.image;
		},
		style(){
			let c = {
				visibility:  this.isVisible? 'visible':'hidden'
			}
			for(let p in this.constrain) {
				const cv = this.constrain[p];
                c[p] = cv === null? `${this.block[p] + this.getFillVal()}px`: `${cv}px`;
			}
			return c;
		},
        isExpanded(){
            return this._config?.fill ?? false;
        },
		productDesc(){
	        const altText = this.blockData.products.filter(product => product.contents !== null).map(product => product.contents)
	        return altText.length > 0 ? altText : this.blockData.altText || "";
        },
	}
}
</script>

<style scoped>
	img {
		object-fit: cover;
		object-position: center;
	}
  .expand{
    object-fit: fill !important;
  }
</style>
